<template>
    <div class="form-attribute">
        <display-type :label="field.label" :type="parseInt(field.type)" :placeholder="field?.placeholder" :suffix="field?.unit" :options="field?.options" />
    </div>
</template>

<script>
import DisplayType from '../../input-type/DisplayType.vue';

export default {
    name: 'Brick',
    components: { DisplayType },
    data() {
        return {
            value: 0,
        };
    },
    props: {
        field: {
            type: Object,
        },
    },
};
</script>
